import type { FaireProductEntity } from "../../entity_types/product";

export const p_q4tywxnrzn: FaireProductEntity = {
  token: "p_q4tywxnrzn",
  type: "product",
  name: "Cow Training Chopsticks Plastic With Adjustable Silicone Finger Rings (6/24/144)",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/146cf935e279e832faf92797b9b89678b358769852cdc8cb736917f5fe476a32.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/067532956646026835c525c3be95ffd16ddc90d01f659cdc00a2050a0b327837.jpeg",
    "https://cdn.faire.com/fastly/935b8cc242faa6a6a30b8b2f69c189565bd5927a2720f9c98313f9d7c26d441d.jpeg",
    "https://cdn.faire.com/fastly/85cc7c3b0eadc32e23da81b7ae451939826aca3cc16ea07d344e0e306e5d2033.jpeg",
    "https://cdn.faire.com/fastly/994e683c2849e838d4bd6b462678261e9768ff5c754c41fbb13b0ec847f3e241.jpeg"
  ],
  priceDollars: 1.75,
  description: "Size: 7.4\"L x 1.5\"W\n\nInner Pack : 6pc Case Pack : 144pc\n\nMaterial: ABS Plastic/Silicone\n\nOrigin: China\n\n\n",
  tags: [],
  msrpDollars: 3.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:50.495Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
